<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> Lessons</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Provider id:</label>
                    <div class="control">
                        <span>{{item.provider_id}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Name:</label>
                  <div class="control">
                    <span>{{item.name}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Words:</label>
                    <div class="control">
                        <span>{{item.words}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12" v-if="item.school">
                <div class="field">
                  <label class="label">School:</label>
                  <div class="control">
                    <span>{{item.school.name}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-2 is-offset-8 is-pulled-right"> 
                <router-link v-bind:to="{ name: 'lesson-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>                
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import LessonRepo from '../../repos/LessonRepo'
import lodash from 'lodash'

export default {
  name: 'lessons-show',
  components: {},
  data() {
        return {
            repo: new LessonRepo(this.$auth),
            item: {},
        }
  },
  created(){  
    this.getLesson(this.$route.params.id);
  },
  methods: {
    getLesson(id){
        this.repo.show(id).then(response => {            
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/lessons/Show.vue